import { useLayoutEffect, useRef, useState } from 'react'
import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { BareButton } from '@calendly/ui/components/bare-button'
import { BodyText } from '@calendly/ui/components/typography'
import { HtmlParser } from '@calendly/html-parser'
import { RichTextView } from '@calendly/rich-text-editor'
import { useWindowSize } from '@calendly/hooks'
import { useI18n } from 'locales'
import _Container from "expandable_event_type_description-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/expandable_event_type_description.js?styleId=Container";
import _Content from "expandable_event_type_description-Content.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/expandable_event_type_description.js?styleId=Content";
import _ToggleButton from "expandable_event_type_description-ToggleButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/expandable_event_type_description.js?styleId=ToggleButton";

const colorTextPrimary = 'undefined'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'

const LINE_CLAMP = 4

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone'),
    isTablet: useDeviceType('isTablet'),
    isTabletUp: useDeviceType('isTabletUp')
  })
})

const Content = /*#__PURE__*/styled('div', null, {
  displayName: "Content",
  styles: _Content
})

const ToggleButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "ToggleButton",
  styles: _ToggleButton
})

export const ExpandableEventTypeDescription = ({ children, isFlatSpotpicker = false, isDaySelected = false }) => {
  const { i18n } = useI18n()
  const contentRef = useRef(null)
  const [expanded, setExpanded] = useState(false)
  const [showToggle, setShowToggle] = useState(false)
  const { width, height } = useWindowSize()

  useLayoutEffect(() => {
    if (expanded) return

    const element = contentRef.current
    if (!element) return

    setShowToggle(element.scrollHeight > element.clientHeight)
  }, [children, width, height, expanded, isFlatSpotpicker, isDaySelected])

  if (!children) return null

  return (
    <Container isFlatSpotpicker={isFlatSpotpicker} isDaySelected={isDaySelected}>
      <Content ref={contentRef} collapsed={!expanded}>
        <RichTextView>
          {HtmlParser(children)}
        </RichTextView>
      </Content>
      {showToggle && (
        <ToggleButton
          type="button"
          onClick={() => setExpanded((value) => !value)}
        >
          <BodyText as="span" inline size="small" weight="bold" color={colorTextAction}>
            {expanded
              ? i18n.t('booking.event_type_description.less')
              : i18n.t('booking.event_type_description.more')}
          </BodyText>
        </ToggleButton>
      )}
    </Container>
  )
}
